import { render, staticRenderFns } from "./actions-column-customer.vue?vue&type=template&id=fac480f2&"
import script from "./actions-column-customer.vue?vue&type=script&lang=js&"
export * from "./actions-column-customer.vue?vue&type=script&lang=js&"
import style0 from "./actions-column-customer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports